import { Injectable, isDevMode, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  private _router = inject(Router);

  private redirectUrlName = 'redirectUrl';
  private redirectUrlRouterUsing = 'redirectUsingRouter';

  setRedirectUrl(url: string, useRouter = false) {
    this.removeRedirectUrl();
    if (this.isValidUrl(url)) {
      sessionStorage.setItem(this.redirectUrlName, url);
    } else if (useRouter) {
      sessionStorage.setItem(this.redirectUrlName, url);
      sessionStorage.setItem(this.redirectUrlRouterUsing, useRouter.toString());
    }
  }

  goRedirectUrl(redirectUrl: string | undefined) {
    const redirectUsingRouter = Boolean(sessionStorage.getItem(this.redirectUrlRouterUsing));

    this.removeRedirectUrl();

    if (redirectUsingRouter && redirectUrl) {
      this._router.navigate([redirectUrl]);
    } else {
      this.goodbye(redirectUrl);
    }
  }

  goodbye(redirectUrl: string | undefined) {
    window.location.href = redirectUrl ?? window.location.protocol + '//' + window.location.host;
  }

  removeRedirectUrl() {
    sessionStorage.removeItem(this.redirectUrlName);
    sessionStorage.removeItem(this.redirectUrlRouterUsing);
  }

  private isValidUrl(url: string) {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  goToInvalidSession() {
    if (isDevMode()) return;

    this._router.navigate(['invalid-session']).then();
  }
}
